module.exports = __webpack_public_path__ + "static/media/Ueberuns1.4304d6cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Ueberuns1.jpg
// module id = 392
// module chunks = 0